import React from 'react';

import { useLanguage } from '../../context/LanguageContext';

export default function FooterSection() {
const {t}=useLanguage()
    return (
        <footer className="bg-textPrimary text-white p-6 md:p-8">
        
            <div className="mt-8 text-center text-sm border-t pt-4">
                {t('footer.copyright')}
            </div>
        </footer>
    );
}